
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M57.12 57.8H6.79a26.52 26.52 0 0150.33 0zM37.59 18.64a8.87 8.87 0 00-10.68 3.71A12.11 12.11 0 0013 26.24a8.84 8.84 0 00-11 2.35 18.53 18.53 0 0135.68-9.95zM15.25 6.37s9.41.72 12 15.91M14.66 6.53S7 12 12.66 26.34M19.23 21.78l7.69 27.55M32.47 19.14a13.31 13.31 0 10.26-8.07","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    